<div class="pagination-container">
  <app-button [size]="'large'" [type]="'tertiary-black'"
              (click)="goToPage(1)"
              [disabled]="currentPage === 1"
              [iconPosition]="'left'"
              [icon]="'first_page'"></app-button>
  <app-button [size]="'large'" [type]="'tertiary-black'"
              (click)="goToPage(currentPage - 1)"
              [disabled]="currentPage === 1"
              [iconPosition]="'left'"
              [icon]="'chevron_left'"></app-button>
  @for (page of getPaginationPages(); track page) {
    @if (page !== '...') {
      <app-button [size]="'large'" [type]="'tertiary-black'"
                  (click)="goToPage(page)"
                  [buttonClass]="page === currentPage ? 'pagination active' : 'pagination'"
                  [text]="page + ''"></app-button>
    } @else {
      <span class="dots">…</span>
    }
  }
  <app-button [size]="'large'" [type]="'tertiary-black'"
              (click)="goToPage(currentPage + 1)"
              [disabled]="currentPage === totalPages"
              [iconPosition]="'right'"
              [icon]="'chevron_right'"></app-button>
  <app-button [size]="'large'" [type]="'tertiary-black'"
              (click)="goToPage(totalPages)"
              [disabled]="currentPage === totalPages"
              [iconPosition]="'right'"
              [icon]="'last_page'"></app-button>
</div>